import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }
const _hoisted_4 = { class: "dialog-footer" }

import Pagination from '@/components/Pagination.vue'
import { useRouter } from 'vue-router'
import { getCurrentInstance, reactive, onActivated, ref } from 'vue'
import { getBrandListApi } from '@/apis/brand'
import { BrandM } from '@/models/brand'
import { getCurrentDate } from '@/utils/index'
import { getProductListApi } from '@/apis/product'
    interface StockI {
        id?: string,
        brand_id: string,
        gl_id: string, //商品
        stock_at: string,
        stock_num: string | number,
        min?:number,
    }
    interface productListI {
        [key: number]: any[]; 
    }
    //定义商品数组对象
    interface productI {
        id:any,
        title:string
    }
    //定义商品数组
    
export default /*@__PURE__*/_defineComponent({
  __name: 'StockList',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const router = useRouter()
    const filters = reactive({
            product_name:         '',     // 商品名称
            start_time:         '',     // 开始日期
            end_time:           '',     // 结束日期
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
    })
    const state =reactive({
        dialogVisible: false,   // 弹框
        isNew:true, //是否显示添加按钮
    })
    const productListMap = ref<productListI>({})
    const stockData = ref<StockI[]>([])
    //商品列表对象
    const productList = ref<productI[]>([])
    //库存列表
    const tableData = ref([])
    //库存列表对象
    const total = ref(0)
    // 获取列表数据
    const getList = () => {
        proxy.$http.get('/admin/shop_product/cake_stock_info', filters).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            tableData.value = data.data
            tableData.value.forEach(item => {
                item.min = item.stock_num; 
            });
            total.value = data.total
        })
    }
    //打开弹窗
    const openDialog = (row) => {
        if(row.id) {
            row.type=2
            delete row.title;
            delete row.brand_name;
            stockData.value.push(row)
            //弹窗打开则触发change事件
            onSelected(row.brand_id)
            state.isNew = false
        }else {
            //当前是添加操作
            addRow()
            state.isNew = true;
        }
        state.dialogVisible = true
    }
    // 关闭弹框
    const dialogBeforeClose = () => {
        state.dialogVisible = false
        //清除所有表格内的元素和数据
        stockData.value = []
        getList()
    }
      // 添加行
    const addRow = () => {
        const newRow = {
            brand_id:'',
            // brand_name: '',
            // title: '',
            gl_id: '',//商品
            stock_at: '',
            stock_num: '',
            type: 2 //2表示商品库存
        };
        
        stockData.value.push(newRow);
    }
    // 删除行
    const removeRow = (index) => {
    //   const index = tableData.value.indexOf(row);
      stockData.value.splice(index, 1);
    };
    //删除库存
    const removeStock = (id) => {
        proxy.$confirm('是否删除该时间库存', '提示', {
            type: 'warning'
        }).then(() => {
            proxy.$http.post('/admin/shop_product/cake_stock_del', {id:id}).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: '删除成功' })
                getList()
            })
        }).catch(() => {
            console.log('取消删除')
        })
    }
    const checkStockData = () => {
        const hasEmptyRow = stockData.value.some(row => {
            return !row.brand_id || !row.gl_id|| !row.stock_at || !row.stock_num;
        });
        return hasEmptyRow
    }
    const disabledDate = (date) => {
        const currentDate = new Date();
        return date.getTime() < currentDate.getTime();
    }
    //库存必须大于0
    const StockNum = (val) => {
        if(val<=0) {
            return val=1;
        }
    }
    //新增/修改库存
    const updateRow = () => {
        if(checkStockData()){
            // 弹出错误提示框，提示用户有空元素
           return proxy.$message({ type: 'error', message: '不能有空元素' })
        }
        stockData.value = stockData.value.map(item => {
            delete item.min;
            return item;
        });
        proxy.$http.post('/admin/shop_product/cake_stock_save',{stock_data:stockData.value}).then(res => {
            const { code, data, msg } = res
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            proxy.$message({ type: 'success', message: '保存成功' })
            dialogBeforeClose()
        })
    }
    //获取品牌列表
    const brandProps = ref({
        value: 'id',
        label: 'name'
    })
    const brandList = ref<BrandM[]>([])
    const onGetBrandList = async () => {
        const {code, data, msg} = await getBrandListApi({if_body:0,id_show:1,cat_id:1}) as any
        if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
        brandList.value = data
    }
    onGetBrandList()
     // 使用 $set 方法设置属性
    const setProductListMap = (key: string, value: any[]) => {
        productListMap[key] = value;
    }
    //选中品牌联动商品列表
    const onSelectedChange = async (brandId,index) => {
        stockData.value[index].gl_id = '';
        if(brandId){
            const { code, data, msg } = await getProductListApi({brand_id:brandId}) as any
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            productList.value = data
            setProductListMap(brandId,data)
        }
    }
    //修改时品牌联动商品列表获取商品名
    const onSelected = async (brandId) => {
            const { code, data, msg } = await getProductListApi({brand_id:brandId}) as any
            if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
            productList.value = data
    }
    const getProductListByBrand = (brandId) => {
        const productList = productListMap[brandId] || [];
        return productList.map((item, index) => ({ ...item, index }));
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    onActivated(() => {
        getList()
    })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.product_name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.product_name) = $event)),
        placeholder: "商品名称",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_time,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.start_time) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "开始日期",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_time,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.end_time) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "结束日期",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[6] || (_cache[6] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: openDialog
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("添加")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      ref: "multipleTableRef",
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, { type: "index" }),
        _createVNode(_component_el_table_column, {
          prop: "brand_name",
          label: "品牌"
        }),
        _createVNode(_component_el_table_column, {
          prop: "title",
          label: "商品"
        }),
        _createVNode(_component_el_table_column, {
          prop: "stock_at",
          label: "日期"
        }),
        _createVNode(_component_el_table_column, {
          prop: "stock_num",
          label: "库存"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          width: "210"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_button, {
                disabled: new Date(scope.row.stock_at) < new Date(_unref(getCurrentDate)()),
                type: "primary",
                title: new Date(scope.row.stock_at) < new Date(_unref(getCurrentDate)()) ? '过期库存不可修改':'',
                size: "small",
                onClick: ($event: any) => (openDialog(scope.row))
              }, {
                default: _withCtx(() => _cache[9] || (_cache[9] = [
                  _createTextVNode(" 修改 ")
                ])),
                _: 2
              }, 1032, ["disabled", "title", "onClick"]),
              _createVNode(_component_el_button, {
                type: "danger",
                disabled: new Date(scope.row.stock_at).getTime() <= Date.now(),
                title: new Date(scope.row.stock_at).getTime() <= Date.now() ? '当天库存、过期库存不可删除':'',
                size: "small",
                onClick: ($event: any) => (removeStock(scope.row.id))
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode(" 删除 ")
                ])),
                _: 2
              }, 1032, ["disabled", "title", "onClick"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      total: total.value,
      currentPage: filters.page,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["total", "currentPage"]),
    _createVNode(_component_el_dialog, {
      title: "添加/修改库存",
      width: 1100,
      modelValue: state.dialogVisible,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((state.dialogVisible) = $event)),
      "before-close": dialogBeforeClose
    }, {
      footer: _withCtx((scope) => [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(_component_el_button, {
            type: "primary",
            size: "small",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (updateRow()))
          }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("保存")
            ])),
            _: 1
          }),
          (state.isNew)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                size: "small",
                onClick: addRow
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("添加")
                ])),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: stockData.value,
          border: "",
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { type: "index" }),
            _createVNode(_component_el_table_column, {
              label: "品牌",
              prop: "brand_name"
            }, {
              default: _withCtx((scope) => [
                (state.isNew == true)
                  ? (_openBlock(), _createBlock(_component_el_select_v2, {
                      key: 0,
                      disabled: !state.isNew,
                      modelValue: scope.row.brand_id,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.brand_id) = $event),
                      placeholder: "请选择品牌",
                      filterable: "",
                      clearable: "",
                      onChange: ($event: any) => (onSelectedChange(scope.row.brand_id,scope.$index)),
                      options: brandList.value,
                      props: brandProps.value
                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange", "options", "props"]))
                  : (state.isNew == false)
                    ? (_openBlock(), _createBlock(_component_el_select_v2, {
                        key: 1,
                        disabled: !state.isNew,
                        modelValue: scope.row.brand_id,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.brand_id) = $event),
                        placeholder: "请选择品牌",
                        filterable: "",
                        clearable: "",
                        onChange: ($event: any) => (onSelected(scope.row.brand_id)),
                        options: brandList.value,
                        props: brandProps.value
                      }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange", "options", "props"]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "商品",
              prop: "title",
              width: "300px",
              "popper-append-to-body": ""
            }, {
              default: _withCtx((scope) => [
                (state.isNew == true)
                  ? (_openBlock(), _createBlock(_component_el_select, {
                      key: 0,
                      disabled: !scope.row.brand_id || !state.isNew,
                      modelValue: scope.row.gl_id,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.gl_id) = $event),
                      width: 500,
                      filterable: "",
                      clearable: ""
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getProductListByBrand(scope.row.brand_id), (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.id,
                            label: item.title,
                            value: item.id
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"]))
                  : (state.isNew == false)
                    ? (_openBlock(), _createBlock(_component_el_select, {
                        key: 1,
                        disabled: !scope.row.brand_id || !state.isNew,
                        modelValue: scope.row.gl_id,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.gl_id) = $event),
                        width: 500,
                        filterable: "",
                        clearable: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productList.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.title,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["disabled", "modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "日期",
              prop: "stock_at"
            }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_date_picker, {
                  disabled: !state.isNew,
                  type: "date",
                  modelValue: scope.row.stock_at,
                  "onUpdate:modelValue": ($event: any) => ((scope.row.stock_at) = $event),
                  disabledDate: disabledDate,
                  placeholder: "请输入日期",
                  "value-format": "YYYY-MM-DD",
                  clearable: ""
                }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "库存",
              prop: "stock_num",
              width: 130
            }, {
              default: _withCtx((scope) => [
                (scope.row.stock_at == _unref(getCurrentDate)())
                  ? (_openBlock(), _createBlock(_component_el_input, {
                      key: 0,
                      type: "number",
                      modelValue: scope.row.stock_num,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.stock_num) = $event),
                      placeholder: "请输入库存",
                      step: 1,
                      min: scope.row.min,
                      max: Infinity,
                      controls: false,
                      onInput: ($event: any) => (scope.row.stock_num <=0 || scope.row.stock_num.includes('.') ? scope.row.stock_num='':null),
                      title: StockNum(scope.row.stock_num) ? '当天库存只能增加':'',
                      clearable: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "min", "onInput", "title"]))
                  : (_openBlock(), _createBlock(_component_el_input, {
                      key: 1,
                      type: "number",
                      modelValue: scope.row.stock_num,
                      "onUpdate:modelValue": ($event: any) => ((scope.row.stock_num) = $event),
                      placeholder: "请输入库存",
                      min: 1,
                      step: 1,
                      onInput: ($event: any) => (scope.row.stock_num <=0 || scope.row.stock_num.includes('.') ? scope.row.stock_num='':null),
                      title: StockNum(scope.row.stock_num) ? '库存必须大于0且不可输入小数':'',
                      clearable: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput", "title"]))
              ]),
              _: 1
            }),
            (state.isNew)
              ? (_openBlock(), _createBlock(_component_el_table_column, {
                  key: 0,
                  label: "操作",
                  width: 80
                }, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "small",
                      onClick: ($event: any) => (removeRow(scope.$index))
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode("删除")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})